export var FETCH_POTENTIAL_ACCOUNTS_REQUEST = 'FETCH_POTENTIAL_ACCOUNTS_REQUEST';
export var FETCH_POTENTIAL_ACCOUNTS_SUCCEEDED = 'FETCH_POTENTIAL_ACCOUNTS_SUCCEEDED';
export var FETCH_POTENTIAL_ACCOUNTS_FAILED = 'FETCH_POTENTIAL_ACCOUNTS_FAILED';
export var FETCH_IMPORTED_ACCOUNTS_REQUEST = 'FETCH_IMPORTED_ACCOUNTS_REQUEST';
export var FETCH_IMPORTED_ACCOUNTS_SUCCEEDED = 'FETCH_IMPORTED_ACCOUNTS_SUCCEEDED';
export var FETCH_IMPORTED_ACCOUNTS_FAILED = 'FETCH_IMPORTED_ACCOUNTS_FAILED';
export var ADD_ACCOUNT_REQUEST = 'ADD_ACCOUNT_REQUEST';
export var ADD_ACCOUNT_SUCCEEDED = 'ADD_ACCOUNT_SUCCEEDED';
export var ADD_ACCOUNT_FAILED = 'ADD_ACCOUNT_FAILED';
export var VERIFY_ACCOUNT_TOKEN_REQUEST = 'VERIFY_ACCOUNT_TOKEN_REQUEST';
export var VERIFY_ACCOUNT_TOKEN_SUCCEEDED = 'VERIFY_ACCOUNT_TOKEN_SUCCEEDED';
export var VERIFY_ACCOUNT_TOKEN_FAILED = 'VERIFY_ACCOUNT_TOKEN_FAILED';
export var OPEN_ADD_ACCOUNT = 'OPEN_ADD_ACCOUNT';
export var OPEN_SET_LABEL = 'OPEN_SET_LABEL';
export var SET_LABEL = 'SET_LABEL';
export var ADD_ACCOUNT_WEBMAIL_REQUEST = 'ADD_ACCOUNT_WEBMAIL_REQUEST';
export var CREATE_ACCOUNT_SUCCEEDED = 'CREATE_ACCOUNT_SUCCEEDED';
export var SET_UPLOAD_PROGRESS = 'SET_UPLOAD_PROGRESS';
export var UPLOAD_CONTACTS_REQUEST = 'UPLOAD_CONTACTS_REQUEST';
export var UPLOAD_CONTACTS_SUCCEEDED = 'UPLOAD_CONTACTS_SUCCEEDED';
export var UPLOAD_CONTACTS_FAILED = 'UPLOAD_CONTACTS_FAILED';
export var RESET_UPLOAD_FILE = 'RESET_UPLOAD_FILE';
export var FETCH_CONTACTS_REQUEST = 'FETCH_CONTACTS_REQUEST';
export var FETCH_CONTACTS_SUCCEEDED = 'FETCH_CONTACTS_SUCCEEDED';
export var FETCH_CONTACTS_FAILED = 'FETCH_CONTACTS_FAILED';
export var UPDATE_CONTACT_REQUEST = 'UPDATE_CONTACT_REQUEST';
export var UPDATE_CONTACT_SUCCEEDED = 'UPDATE_CONTACT_SUCCEEDED';
export var UPDATE_CONTACT_FAILED = 'UPDATE_CONTACT_FAILED';
export var VALIDATE_CONTACTS_LIST_REQUEST = 'VALIDATE_CONTACTS_LIST_REQUEST';
export var VALIDATE_CONTACTS_LIST_SUCCEEDED = 'VALIDATE_CONTACTS_LIST_SUCCEEDED';
export var VALIDATE_CONTACTS_LIST_FAILED = 'VALIDATE_CONTACTS_LIST_FAILED';
export var DELETE_POTENTIAL_ACCOUNT_REQUEST = 'DELETE_POTENTIAL_ACCOUNT_REQUEST';
export var DELETE_POTENTIAL_ACCOUNT_SUCCEEDED = 'DELETE_POTENTIAL_ACCOUNT_SUCCEEDED';
export var DELETE_POTENTIAL_ACCOUNT_FAILED = 'DELETE_POTENTIAL_ACCOUNT_FAILED';
export var ADD_BLACKLIST_REQUEST = 'ADD_BLACKLIST_REQUEST';
export var ADD_BLACKLIST_SUCCEEDED = 'ADD_BLACKLIST_SUCCEEDED';
export var ADD_BLACKLIST_FAILED = 'ADD_BLACKLIST_FAILED';
export var GET_IMPORT_IDS_REQUEST = 'GET_IMPORT_IDS_REQUEST';
export var GET_IMPORT_IDS_SUCCEEDED = 'GET_IMPORT_IDS_SUCCEEDED';
export var GET_IMPORT_IDS_FAILED = 'GET_IMPORT_IDS_FAILED';
export var REMOVE_BLACKLIST_REQUEST = 'REMOVE_BLACKLIST_REQUEST';
export var REMOVE_BLACKLIST_SUCCEEDED = 'REMOVE_BLACKLIST_SUCCEEDED';
export var REMOVE_BLACKLIST_FAILED = 'REMOVE_BLACKLIST_FAILED';
export var BLACKLIST_CONTACTS_PROGRESSION = 'BLACKLIST_CONTACTS_PROGRESSION';
export var ADD_EMAIL_AS_VIEWED_DURING_SESSION = 'ADD_EMAIL_AS_VIEWED_DURING_SESSION';
;
